import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Button, Flex, Image, Modal, notification } from "antd";
import { useState } from "react";
import { BannerService } from "../../services/BannerService";
import CreateBanner from "./CreateBanner";

export default function Banner() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Picture',
            align: 'center',
            dataIndex: 'picture',
            key: 'picture',
            render: (value, record) => {
                return <Image src={value.fullpath} width={150}></Image>
            },
        },
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Name (TH)',
            align: 'center',
            dataIndex: 'name_th',
            key: 'name_th',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Name (EN)',
            align: 'center',
            dataIndex: 'name_en',
            key: 'name_en',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'URL Link',
            align: 'center',
            dataIndex: 'url_link',
            key: 'url_link',
            render: (value, record) => {
                return <div className="new-line" style={{ width: 200}}>{value}</div>
            },
        },
        {
            title: 'Type',
            align: 'center',
            dataIndex: 'type',
            key: 'type',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Is Public',
            align: 'center',
            dataIndex: 'is_public',
            key: 'is_public',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Is Affiliate',
            align: 'center',
            dataIndex: 'is_affiliate',
            key: 'is_affiliate',
            render: (value, record) => {
                return value
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div>
                        <div onClick={() => onDelete(record.id)} >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </div>
                    </Flex>
                )
            }
        },

    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await BannerService.getBanners(payload)
        return res
    }

    const onDelete = async (id: number) => {
        const res = await BannerService.deleteBanner(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }



    return (
        <>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateBanner
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateBanner>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Banner',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Manage Banner"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
